package com.fireavert.reports_page.reports_data_export.data_models.responses

import com.fireavert.reports_page.reports_data_export.data_models.ReportsExportDataModel
import kotlinx.serialization.Serializable

@Serializable
data class ReportsExportDialogResponse(
    val propertyEventMap: Map<String, List<ReportsExportDataModel>>,
)